import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--optional"
export default class extends Controller {
  static targets = ["hope"];
  static values = {
    recentJobTypeSelected: Boolean,
  };
  connect() {}

  toggle(e) {
    if (this.recentJobTypeSelectedValue) return;

    this.hopeTarget.value = e.target.value;
    this.recentJobTypeSelectedValue = true;
  }
}
